export enum Screen {
  WelcomeBack = 'WelcomeBack',
  PrimaryGoal = 'PrimaryGoal',
  AnnualFees = 'AnnualFees',
  CreditScore = 'CreditScore',
  Register = 'Register',
  Registration = 'Registration', // registration v3

  // travel flow
  InternationalTravel = 'InternationalTravel',
  AirlineChoice = 'AirlineChoice',
  HotelChoice = 'HotelChoice',
  MonthlySpend = 'MonthlySpend',
  SpecificAirlineOrHotel = 'SpecificAirlineOrHotel',
  LuxuryPerks = 'LuxuryPerks',
  RewardsAndPerks = 'RewardsAndPerks',
  SpendingCategories = 'SpendingCategories',

  // cash-back flow
  CashBackPreference = 'CashBackPreference',
  ManagingCategories = 'ManagingCategories',
  CashBackBigPurchase = 'CashBackBigPurchase',
  CashBackSpendingCategories = 'CashBackSpendingCategories',

  // debt flow
  IsDebtCreditCard = 'IsDebtCreditCard',
  TypeOfDebt = 'TypeOfDebt',
  CurrentBalanceCompany = 'CurrentBalanceCompany',
  AddDebtScreen = 'AddDebtScreen',

  // build credit
  CreditHistory = 'CreditHistory',
  CollegeStudent = 'CollegeStudent',
  CardDeposit = 'CardDeposit',
  SecurityDeposit = 'SecurityDeposit',
  StudentSpendingCategories = 'StudentSpendingCategories',

  //Big purchase
  HowLongToPayOffDebt = 'HowLongToPayOffDebt',
  IntroAPROrRewards = 'IntroAPROrRewards',
  PurchaseSpend = 'PurchaseSpend',
  PurchaseSpendingCategories = 'PurchaseSpendingCategories',
  PurchaseSpendInput = 'PurchaseSpendInput',

  // Final screen
  Auth0 = 'Auth0',
  Loading = 'Loading',
  ResultsPage = 'Results',
}
